import { RightArrowIcon } from "staysure-component-library";

import ButtonWrapper from "@/app/shared-components/button-wrapper/button-wrapper";
import RichText from "@/app/shared-components/rich-text/rich-text";

import { useTravelDatesContext } from "../../../providers/travel-dates.provider";

export default function Body() {
  const { groupedMagnoliaData, keyForGroupedMagnolia, setIsDrawerOpen } =
    useTravelDatesContext();
  const { body, isLoadMoreButton, loadMoreButtonText } =
    groupedMagnoliaData?.[keyForGroupedMagnolia]?.descriptionSection ?? {};
  return (
    <div className={`w-full md:p-0 rounded-radius-lg md:border-none `}>
      <div
        className={` md:text-xs leading-[24px] md:leading-[27px] 
          text-2xs md:mb-spacing-m  text-surface-neutral-option-2`}
      >
        <RichText richText={body} />
      </div>

      {isLoadMoreButton && loadMoreButtonText && (
        <div className="load-more-wrapper text-center">
          <ButtonWrapper
            label={loadMoreButtonText}
            hierarchy="tertiary"
            semanticColor="Dark Background"
            id="load-more-button"
            className="text-center font-semibold text-xs !leading-custom-size-xxl"
            isRightIcon
            rightIcon={<RightArrowIcon stroke="white" />}
            onClick={() => setIsDrawerOpen(true)}
          />
        </div>
      )}
    </div>
  );
}
